import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { ATTENDANCES_TABS_MODEL, USER_TYPE_MODAL_MODEL } from '../Model/Model';
import { permissionObj } from '../../../../Helpers/permission';
import {CreateUserInvitationEvent, GetAllVisitorTypes} from "../../../../reduxToolkit/EmployeeEvents/EmployeeEventsApi";
import {useParams} from "react-router-dom";
import {toast} from "react-toastify";
import {errorMsg} from "../../../../Apis/functions";
import {USER_TYPE_MODEL} from "../../../../enums/userTypeEnum";
import {EVENT_INVITATION_MODEL} from "../Manage/Model/Model";

/**
 * @Author: Susana García Rodríguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 */
const AddUserTypeModalApp = (props) => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const { show, activeTab,  onHide, setModified, setSearchElement, userList, setUserList } = props;
    const [visitorType, setVisitorType] = useState(null);
    const [modalTitleKey, setModalTitleKey] = useState('');
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const permissionVisitors =  DEV || permission?.includes(permissionObj.WEB_VISITOR_CREATE);
    const { t } = useTranslation();
    const activeTabName = Object.values(ATTENDANCES_TABS_MODEL).find((tab) => tab.id === activeTab)?.name;
    const getAllVisitorTypes = useSelector((state) => state?.EmployeeEventsSlice?.getAllVisitorTypes);
    const [emptyFields, setEmptyFields] = useState(false);
    const [item, setItem] = useState({...EVENT_INVITATION_MODEL, eventId: id});

    // Updates modal title and fetches visitor types when modal opens
    useEffect(() => {
        if (!show) return;
        setModalTitleKey(USER_TYPE_MODAL_MODEL[activeTabName]?.titleKey);
    }, [dispatch, activeTab, show]);


     // Resets data when modal is closed
    useEffect(() => {
        if (!show) {
            setUserList([]);
            setVisitorType(undefined);
        }
    }, [show]);


    useEffect(() => {
       if(activeTab === USER_TYPE_MODEL.VISITOR ) dispatch(GetAllVisitorTypes());
    }, [show ])

    const onConfirm = () => {
        if(userList?.length === 0 || (activeTab === USER_TYPE_MODEL.VISITOR && visitorType === null) ){
            setEmptyFields(true);
            return;
        }

        setEmptyFields(false);

        dispatch(CreateUserInvitationEvent(item.toRegister({userList, userTypeId: activeTab, visitorType})))
            .then(({payload: {data: { code, success},},}) => {
                if (success === true) {
                    toast.success(t("has_been_created_successfully"));
                    setModified(true);
                    setSearchElement("")
                    onHide();
                    setUserList([]);
                }else errorMsg(code)
            },
        );
    }

    return {
        modalTitleKey,
        t,
        visitorType,
        setVisitorType,
        permissionVisitors,
        visitorTypes:getAllVisitorTypes,
        emptyFields,
        onConfirm
    };
};

export default AddUserTypeModalApp;
